<template>
  <div class="main">
    <PinnedBtnContainer>
      <PinnedRuleBtn />
    </PinnedBtnContainer>
    <img class="img" src="../assets/images/lalamove-error.png" alt="unlucky" />
    <div class="text"><slot></slot></div>
  </div>
</template>

<script>
import PinnedBtnContainer from '@/components/templates/common/PinnedBtnContainer';
import PinnedRuleBtn from '@/components/templates/common/PinnedRuleBtn.vue';

export default {
  components: { PinnedBtnContainer, PinnedRuleBtn },
  props: {
    text: {
      type: String
    }
  }
};
</script>

<style lang="less" scoped>
.main {
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #f3f4f5;

  .img {
    width: 360px;
    height: 262px;
    margin-bottom: 10px;
  }

  .text {
    width: 600px;
    font-size: 30px;
    color: #8c8c8c;
    text-align: center;
  }
}
</style>
